/* ============================================================
   BLANKPILL — Cart drawer AOV upsell + free-shipping ($60) nudge.
   Shows "Add $X to unlock free shipping" with a progress bar and
   2-3 recommended add-on products (one-click add for single-
   variant items, "Choose" link for sized items). Self-contained
   styles. Registered in snippets/blankpill-head.liquid.
   Reversible: remove this file + its <script> tag.
   ============================================================ */

(function () {
  'use strict';

  var THRESHOLD = 6000; // free shipping unlocks at $60 (cents)
  var PANEL_CLASS = 'bp-upsell';
  var MAX_RECS = 3;

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function withWidth(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function injectStyle() {
    if (document.getElementById('bp-upsell-css')) return;
    var s = document.createElement('style');
    s.id = 'bp-upsell-css';
    s.textContent =
      '.bp-upsell{border-top:1px solid rgba(0,0,0,.1);padding:14px 16px;font-family:inherit}' +
      '.bp-upsell__msg{font-size:13px;color:#111;margin-bottom:8px;text-align:center}' +
      '.bp-upsell__msg strong{font-weight:800}' +
      '.bp-upsell__tick{color:#16a34a;font-weight:800}' +
      '.bp-upsell__track{height:6px;border-radius:99px;background:rgba(0,0,0,.08);overflow:hidden;margin-bottom:12px}' +
      '.bp-upsell__fill{height:100%;background:#111;border-radius:99px;transition:width .4s ease}' +
      '.bp-upsell__fill.is-full{background:#16a34a}' +
      '.bp-upsell__label{font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#666;margin-bottom:8px;font-weight:700}' +
      '.bp-upsell__items{display:flex;flex-direction:column;gap:8px}' +
      '.bp-upsell__card{display:flex;align-items:center;gap:10px}' +
      '.bp-upsell__thumb{flex:0 0 auto;width:44px;height:44px;border-radius:8px;overflow:hidden;background:#f3f3f3}' +
      '.bp-upsell__thumb img{width:100%;height:100%;object-fit:cover;display:block}' +
      '.bp-upsell__info{flex:1 1 auto;min-width:0;display:flex;flex-direction:column}' +
      '.bp-upsell__name{font-size:12.5px;color:#111;text-decoration:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      '.bp-upsell__price{font-size:12px;color:#666;font-weight:700}' +
      '.bp-upsell__add{flex:0 0 auto;border:1px solid #111;background:#e8f65c;color:#111;font-weight:800;font-size:12px;border-radius:8px;padding:7px 12px;cursor:pointer;text-decoration:none;line-height:1;white-space:nowrap}' +
      '.bp-upsell__add:hover{background:#111;color:#e8f65c}' +
      '.bp-upsell__choose{background:#fff}' +
      '.bp-upsell__bundle{font-size:12px;color:#444;text-align:center;margin:-2px 0 10px;font-weight:600}';
    document.head.appendChild(s);
  }

  function recsFor(productId) {
    if (!productId) return Promise.resolve([]);
    var base = '/recommendations/products.json?product_id=' + productId + '&limit=10&intent=';
    return fetch(base + 'complementary', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var list = (d && d.products) || [];
        if (list.length) return list;
        return fetch(base + 'related', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d2) { return (d2 && d2.products) || []; });
      })
      .catch(function () { return []; });
  }

  function cardHtml(p) {
    var single = p.variants && p.variants.length === 1 && p.variants[0];
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var priceCents = (typeof p.price === 'number') ? p.price : (p.variants && p.variants[0] ? p.variants[0].price : 0);
    var title = (p.title || '').replace(/"/g, '&quot;');
    var action = single
      ? '<button type="button" class="bp-upsell__add" data-vid="' + p.variants[0].id + '">+ Add</button>'
      : '<a class="bp-upsell__add bp-upsell__choose" href="' + p.url + '">Choose</a>';
    return '<div class="bp-upsell__card">' +
      '<a href="' + p.url + '" class="bp-upsell__thumb">' + (img ? '<img src="' + withWidth(img, 120) + '" alt="' + title + '" loading="lazy">' : '') + '</a>' +
      '<div class="bp-upsell__info">' +
        '<a href="' + p.url + '" class="bp-upsell__name">' + (p.title || '') + '</a>' +
        '<span class="bp-upsell__price">' + money(priceCents) + '</span>' +
      '</div>' + action +
    '</div>';
  }

  function buildPanel(cart, recs) {
    var remaining = Math.max(THRESHOLD - cart.total_price, 0);
    var pct = Math.min((cart.total_price / THRESHOLD) * 100, 100);
    var unlocked = remaining === 0;
    var panel = document.createElement('div');
    panel.className = PANEL_CLASS;
    var msg = unlocked
      ? '<span class="bp-upsell__tick">✓</span> You’ve unlocked <strong>FREE SHIPPING</strong>'
      : 'Add <strong>' + money(remaining) + '</strong> to unlock <strong>FREE SHIPPING</strong>';
    var bar = '<div class="bp-upsell__track"><div class="bp-upsell__fill' + (unlocked ? ' is-full' : '') + '" style="width:' + pct + '%"></div></div>';
    var shirts = 0, hoodies = 0;
    (cart.items || []).forEach(function (i) {
      var t = (i.product_type || '').toLowerCase();
      if (t === 'shirt') shirts += i.quantity;
      if (t === 'hoodie') hoodies += i.quantity;
    });
    var bundleMsg;
    if (shirts >= 2) bundleMsg = '<span class="bp-upsell__tick">✓</span> Bundle deal: <strong>10% off your tees</strong> — automatic at checkout';
    else if (shirts === 1) bundleMsg = 'Add <strong>1 more tee</strong> — get <strong>10% off both</strong>, automatic at checkout';
    else if (hoodies >= 2) bundleMsg = '<span class="bp-upsell__tick">✓</span> Bundle deal: <strong>15% off your hoodies</strong> — automatic at checkout';
    else if (hoodies === 1) bundleMsg = 'Add <strong>1 more hoodie</strong> — get <strong>15% off both</strong>, automatic at checkout';
    else bundleMsg = 'Bundle &amp; Save: any 2 tees = 10% off · any 2 hoodies = 15% off';
    var bundle = '<div class="bp-upsell__bundle">' + bundleMsg + '</div>';
    var recHtml = '';
    if (recs.length) {
      recHtml = '<div class="bp-upsell__label">' + (unlocked ? 'Complete your stack' : 'Add one to get there') + '</div>' +
        '<div class="bp-upsell__items">' + recs.map(cardHtml).join('') + '</div>';
    }
    panel.innerHTML = '<div class="bp-upsell__msg">' + msg + '</div>' + bar + bundle + recHtml;

    panel.addEventListener('click', function (e) {
      var btn = e.target.closest('.bp-upsell__add[data-vid]');
      if (!btn) return;
      e.preventDefault();
      var vid = parseInt(btn.getAttribute('data-vid'), 10);
      btn.textContent = 'Adding…';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
      }).then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(refresh, 160);
        })
        .catch(function () { btn.textContent = 'Try again'; btn.disabled = false; });
    });
    return panel;
  }

  function removeAll() {
    document.querySelectorAll('.' + PANEL_CLASS).forEach(function (n) { n.remove(); });
  }

  function place(panel) {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer) {
      var footer = drawer.querySelector('.cart-drawer__footer, .cart__footer, footer, [class*="footer"]');
      if (footer && footer.parentNode) { footer.parentNode.insertBefore(panel, footer); return true; }
      var inner = drawer.querySelector('.drawer__inner, .cart-drawer__inner, .cart-items, .cart__items');
      if (inner) { inner.appendChild(panel); return true; }
      drawer.appendChild(panel); return true;
    }
    var pageItems = document.querySelector('.cart-items, .cart__items, main .cart');
    if (pageItems && pageItems.parentNode) { pageItems.parentNode.insertBefore(panel, pageItems.nextSibling); return true; }
    return false;
  }

  function refresh() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        removeAll();
        if (!cart || cart.item_count === 0) return;
        injectStyle();
        var firstId = cart.items[0] && cart.items[0].product_id;
        var inCart = {};
        cart.items.forEach(function (i) { inCart[i.product_id] = 1; });
        recsFor(firstId).then(function (recs) {
          recs = (recs || []).filter(function (p) {
            return p.available !== false && !inCart[p.id];
          }).slice(0, MAX_RECS);
          place(buildPanel(cart, recs));
        });
      })
      .catch(function () {});
  }

  function start() {
    refresh();
    document.addEventListener('cart:update', function () { setTimeout(refresh, 80); });
    document.addEventListener('cart:refresh', function () { setTimeout(refresh, 80); });
    try {
      var moT = null;
      var mo = new MutationObserver(function () {
        if (moT) return;
        moT = setTimeout(function () { moT = null; refresh(); }, 200);
      });
      mo.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open', 'aria-hidden'] });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
